import reduceWithSeparator from '@/helpers/reduce-with-separator'

export default {
  covenants () {
    if (!this.user.active_covenants) {
      return
    }

    return reduceWithSeparator(this.user.active_covenants, 'name', ',', 'Não informado')
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/identification/resources/computed.js